var n = function(r) {
  return r.reduce(function(a, t) {
    return Array.isArray(t) ? a.concat(n(t)) : a.concat(t);
  }, []);
}, e = n;
export {
  e as f
};
